import { createAction } from '@ngrx/store';
import { StoreConstants } from '../constants/store-constants';

export const nextStep = createAction(`${StoreConstants.STORE_KEY} Next step`);
export const repeatInstructions = createAction(`${StoreConstants.STORE_KEY} Repeat instructions`);
export const startTest = createAction(`${StoreConstants.STORE_KEY} Start test`);
export const noNav = createAction(`${StoreConstants.STORE_KEY} No navigation`);
